import React, { useEffect } from "react";
import { useQuery } from "react-query";
import axios from "axios";
import { BASE_URL } from "../Constants";
import HomePageComponent from "./HomePageComponent";
import HomePageSkeleton from "./HomePageSkeleton";
import FooterComponent from "./FooterComponent";

const fetchHomePageData = async () => {
  const subcategoriesRequest = axios.get(`${BASE_URL}/api/subcategory/getAll`);
  const trendingRequest = axios
    .get(`${BASE_URL}/api/content/trending`)
    .then((response) => response.data)
    .catch(() => ({ flag: false, contents: [] }));
  const sliderRequest = axios
    .get(`${BASE_URL}/api/slider`)
    .then((response) => response.data)
    .catch(() => ({ flag: false, slides: [] }));

  const [subcategoriesResponse, trending, sliderResponse] = await Promise.all([
    subcategoriesRequest,
    trendingRequest,
    sliderRequest,
  ]);

  const activeSlides =
    sliderResponse?.flag && Array.isArray(sliderResponse?.slides)
      ? sliderResponse.slides.filter(
          (slide) => !slide.status || slide.status === "A"
        )
      : [];

  return {
    subcategories: subcategoriesResponse.data,
    trending,
    slides: activeSlides,
  };
};

function GetAllContent() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data, isLoading, isError } = useQuery(
    "homePageData",
    fetchHomePageData,
    {
      staleTime: 60000, // Adjust as needed
      cacheTime: 3600000, // Adjust as needed
    }
  );
  document.title = "Home | Gangadwar.in | Gangadwar Bhajnawali";
  return (
    <>
      {isLoading ? (
        <>
          <HomePageSkeleton />
          <FooterComponent />
        </>
      ) : isError ? (
        <p className="text-center py-5">Error: Something went wrong!</p>
      ) : (
        <>
          <HomePageComponent
            data={data.subcategories}
            trending={data.trending}
            slides={data.slides}
          />
          <FooterComponent />
        </>
      )}
    </>
  );
}

export default GetAllContent;
